module.exports = __webpack_public_path__ + "assets/photos/memories/frame-10-mobile--467a163e2b308f85648d9a89f11e7041.jpg";